import { render, staticRenderFns } from "./MenuPositionByType.vue?vue&type=template&id=0396bfbd"
import script from "./MenuPositionByType.vue?vue&type=script&lang=js"
export * from "./MenuPositionByType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports